// frontend/src/utils/constants.js - Quick Fix for SSL Issue
// Update the API configuration to use HTTP instead of HTTPS

export const STORAGE_KEYS = {
  auth: {
    token: 'auth_token',
    user: 'auth_user',
    lastActivity: 'auth_last_activity',
    rememberMe: 'auth_remember_me',
  },
};

export const APP_CONFIG = {
  name: 'ExoTrack',
  version: '1.0.0',
  description: 'Professional Attendance Management System',
  author: 'ExoTrack Team',

  // API Configuration - UPDATED FOR HTTP
  api: {
    baseURL: 'http://localhost:3000/api/v1', // Changed from HTTPS to HTTP
    timeout: 30000,
    retryAttempts: 3,
    retryDelay: 1000,
  },

  // Authentication
  auth: {
    tokenKey: 'authToken',
    userKey: 'userData',
    sessionTimeout: 30 * 60 * 1000, // 30 minutes
    refreshTokenThreshold: 5 * 60 * 1000, // 5 minutes before expiry
    maxLoginAttempts: 5,
    lockoutDuration: 15 * 60 * 1000, // 15 minutes
  },

  // Feature Flags
  features: {
    demoMode: import.meta.env.VITE_DEMO_LOGIN === 'true',
    darkMode: false,
    notifications: true,
    realTimeUpdates: true,
    offlineMode: false,
    gpsTracking: true,
    cameraCapture: true,
    fieldWork: true,
    biometricAuth: false,
  },

  // UI Configuration
  ui: {
    theme: 'light',
    primaryColor: '#2563eb',
    animationDuration: 200,
    toastDuration: 5000,
    tablePageSize: 25,
    mobileBreakpoint: 768,
  },
};
